// // Comment these three lines in standalone mode
import { appendMyBetsPlinko, setBetLock, setDemoMyBets, setShowWinAmt } from "../../../slices-thunks/pyramidPlinkoGame.slice";
import store from "redux-store/store.js";
import { countOnes } from "helpers/common.helpers.js";
import { boxBounceEffect, changeNumberOfLines, clearAllBalls, createBall, lightningModeUI, removeLightningMode, setupPayoutText, startMovingBall, setupModes, setWinAmount } from "./gameUI.js";
import { playDropTickSound, playFirstDropSound } from "./soundManager.js";
import { updatePlinkoCreditWalletWaitQueue, updateCreditDemoWalletWaitQueue, updateDemoWalletBalance } from "redux-store/redux/slices/auth.slice.js";
import { isPixiStandAlone, config } from "./settings.js";
import { DEFAULT_PLINKO_LIGHTNING_MODE_BOARD } from "../pyramidPlinkogame.constants.js";
import { WALLET_EMIT_TYPES } from "constants/index";
import { updateBalanceAsync } from "redux-store/thunk/user.thunk";

let autoBet = false;
let noOfBalls = 0;

export function pixiGetAutoBet () {
  return autoBet
}

export function pixiSetAutoBet (_autoBet = false) {
  autoBet = _autoBet
}

export function pixiGetNoOfBalls () {
  return noOfBalls;
}

export function pixiIncrementNoOfBalls () {
  noOfBalls += 1;
}

export function pixiSetNoOfBalls (_noOfBalls) {
  noOfBalls = _noOfBalls;
}

export const pixiCreateBall = (lastBall, winAmt, winAmtStr, multiplierStr) => createBall(lastBall, winAmt, winAmtStr, multiplierStr)

export const pixiStartMovingBall = (ballPath, lastBall, winAmt, winAmtStr, multiplierStr) => {
  pixiIncrementNoOfBalls()
  // incrementActiveBallCount()
  const ballPathArray = ballPath.split('').map(ele => +ele)
  startMovingBall(ballPathArray)
  pixiCreateBall(lastBall, winAmt, winAmtStr, multiplierStr)
}

export const pixiCancelBall = () => clearAllBalls()

export const pixiChangeNumberOfLines = (lines) => changeNumberOfLines(lines)

export const pixiSetPayouts = (payouts) => setupPayoutText(payouts)

export const boxNumbers = {
  Red: 1,
  Orange: 2,
  Pink: 3,
  Purple: 5,
  Blue: 7,
  Green: 8
}

export const boxColor = {
  red: 0xC82020,
  orange: 0xFC6F1F,
  pink: 0xB122F4,
  purple: 0x8951FF,
  blue: 0x346DFF,
  green: 0x3CBCB4,
  yellow: 0xFFBD00,
  white: 0xFFFFFF,
  alpha: 1
}

export const fastModeBox = (dropDetails) => {
  // Comment these lines in standalone mode
  const boxNumber = countOnes(dropDetails)
  boxBounceEffect(boxNumber)
}


export const dispatching = (currentBetWinningAmount) => {
  // Comment this line in standalone mode
  if (!isPixiStandAlone) {
    dispatchRoundEnd(currentBetWinningAmount)
  }
  _ballLandedListener?.()
  releaseBallWaiters()
  // if (isLastBall) {
  //   pixiSetNoOfBalls(0)
  //   store.dispatch(setBetLock())
  // }
}

export const dispatchRoundEnd = (winAmount) => {
  store.dispatch(appendMyBetsPlinko())
  store.dispatch(updateBalanceAsync({ type: WALLET_EMIT_TYPES.CREDIT, amount: winAmount }))
  // const { balance, currencyCode } = getWalletInfo();
  // sendMessageOutsideIframe('credit', { balance: balance, currency: currencyCode })
}

// export const dispatchRoundEnd = (currentBetWinningAmount) => {
//   const demoMode = store.getState()?.auth?.demoMode
//   const demoWallet = store.getState()?.auth?.demoWallet
//   if (demoMode) {
//     if (demoMode) store.dispatch(setDemoMyBets())
//     store.dispatch(updateDemoWalletBalance(demoWallet.balance + currentBetWinningAmount))
//   } else store.dispatch(updatePlinkoCreditWalletWaitQueue({ currentBetWinningAmount }))
//   store.dispatch(setShowWinAmt(true))
//   store.dispatch(updateCreditDemoWalletWaitQueue())
//   store.dispatch(appendMyBetsPlinko())
// }

export const setBallSpeed = (speed) => {  //const value=0.75
  config.ball.animationSpeed = speed
}

export const pixiSlowBall = () => {
  setBallSpeed(0.75)
}

export const pixiFastBall = () => {
  setBallSpeed(2)
}

const data = [
  {
    position: [1, 1],
    multiplier: "3x"
  },
  {
    position: [4, 5],
    multiplier: "7x"
  },
  {
    position: [6, 7],
    multiplier: "12x"
  }
]

export const pixiLightningMode = (
  ballMultipliers = DEFAULT_PLINKO_LIGHTNING_MODE_BOARD.betMultipliers,
  payouts = DEFAULT_PLINKO_LIGHTNING_MODE_BOARD.payouts
) => {
  lightningModeUI(ballMultipliers)
  pixiSetPayouts(payouts)
}

export const pixiNormalMode = (payouts) => {
  removeLightningMode()
  pixiSetPayouts(payouts)
}

export const setGameMode = (index) => {
  setupModes(index)
}

export const setPayoutValue = (str1, str2) => {
  setWinAmount(str1, str2)
}

// Sounds
export const playDropTick = () => {
  playDropTickSound()
}

export const playPositiveWin = () => {
  // playPositiveWinSound()
}

export const playFirstDrop = () => {
  playFirstDropSound()
}

let _isBetInProgress = false;

export function setBetInProgress(val) {
  _isBetInProgress = val;
}

export function getBetInProgress() {
  return _isBetInProgress;
}


let _isAutoBetActive = false;

export function setAutoBetActive(val) {
  _isAutoBetActive = val;
}
export function getAutoBetActive() {
  return _isAutoBetActive;
}

let _isAutoRunning = false;

export function setAutoRunning(val) {
  _isAutoRunning = val;
}

export function getAutoRunning() {
  return _isAutoRunning;
}

let _pendingBets = 0;

export function incrementPendingBets() { _pendingBets++ }
export function decrementPendingBets() { _pendingBets-- }
export function getPendingBets() { return _pendingBets }
export function resetPendingBets() { _pendingBets = 0 }

let _totalAutoBetBalls = 0;
let _landedAutoBetBalls = 0;

export function setTotalAutoBetBalls(val) { _totalAutoBetBalls = val }
export function incrementLandedAutoBetBalls() { _landedAutoBetBalls++ }
export function resetAutoBetBallCounters() { _totalAutoBetBalls = 0; _landedAutoBetBalls = 0 }
export function isAllAutoBetBallsLanded() {
  return _totalAutoBetBalls > 0 && _landedAutoBetBalls >= _totalAutoBetBalls
}

// let activeBallCount = 0;
// let hadOverlap = false;

// export function incrementActiveBallCount() {
//   if (activeBallCount > 0) {
//     hadOverlap = true;   // ← a ball was already falling when this new one started
//   }
//   activeBallCount++;
// }

// export function decrementActiveBallCount() {
//   activeBallCount = Math.max(0, activeBallCount - 1);
// }

// export function getActiveBallCount() {
//   return activeBallCount;
// }

// export function getHadOverlap() {
//   return hadOverlap;
// }

// export function resetOverlapFlag() {
//   hadOverlap = false;
let _autoBetTotalWin = 0;

export function addAutoBetWin(amount) {
  _autoBetTotalWin += Number(amount) || 0;
}

export function resetAutoBetWin() {
  _autoBetTotalWin = 0;
}

export function getAutoBetTotalWin() {
  return _autoBetTotalWin;
}

let _ballLandedListener = null;

export function setBallLandedListener(fn) {
  _ballLandedListener = fn;
}

let _landedWaiters = [];

export function waitForBallLanded() {
  return new Promise((resolve) => _landedWaiters.push(resolve));
}

export function releaseBallWaiters() {
  const waiters = _landedWaiters;
  _landedWaiters = [];
  waiters.forEach((resolve) => resolve());
}
